<Banner
    type={"warning"}
    closable={false}
    text={allResourcesBannerText}
    visible={allResourcesBannerVisible}
/>
<Banner
    text={participantsBannerText}
    close={close}
    visible={participantsBannerVisible}
/>

<script>
    import { formatLanguageString } from "@itslearning/atlas/strings/format";
    import Banner from "@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte";
    import i18n from "@its-ui/planner-common/i18n";

    export let close = i18n.close;
    export let groupCount = parent.location.search.includes("g") ? parseInt(new URLSearchParams(parent.location.search).get("g")) : 0;
    export let participantCount = parent.location.search.includes("p") ? parseInt(new URLSearchParams(parent.location.search).get("p")) : 0;
    export let showDefaultBanner = false;

    const bannerTextMap = [
        { condition: (p, g) => p === 1 && g === 0, text: i18n.connectedPlanAssignedTo1Participant },
        { condition: (p, g) => p > 1 && g === 0, text: (p) => formatLanguageString(i18n.connectedPlanAssignedToXParticipants, p) },
        { condition: (p, g) => p === 0 && g === 1, text: i18n.connectedPlanAssignedTo1Group },
        { condition: (p, g) => p === 0 && g > 1, text: (p, g) => formatLanguageString(i18n.connectedPlanAssignedToYGroups, g) },
        { condition: (p, g) => p === 1 && g === 1, text: i18n.connectedPlanAssignedTo1Participant1Group },
        { condition: (p, g) => p === 1 && g > 1, text: (p, g) => formatLanguageString(i18n.connectedPlanAssignedTo1ParticipantYGroups, g) },
        { condition: (p, g) => p > 1 && g === 1, text: (p, g) => formatLanguageString(i18n.connectedPlanAssignedToXParticipants1Group, p) },
        { condition: (p, g) => p > 1 && g > 1, text: (p, g) => formatLanguageString(i18n.connectedPlanAssignedToXParticipantsYGroups, p, g) },
    ];

    $: participantsBannerText = participantCount === 0 && groupCount === 0 ? "" : getBannerText(participantCount, groupCount);
    $: participantsBannerVisible = participantsBannerText !== "";

    $: allResourcesBannerText = showDefaultBanner ? i18n.assignToTerms.allResourcesWillBePlacedInOnePlanFolder : "";
    $: allResourcesBannerVisible = allResourcesBannerText !== "";

    const getBannerText = (participantCount, groupCount) => {
        const entry = bannerTextMap.find(({ condition }) => condition(participantCount, groupCount));

        return entry ? (typeof entry.text === 'function' ? entry.text(participantCount, groupCount) : entry.text) : "";
    };
</script>
